import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { staticPreviewPath } from '@/lib/design-preview-path';
import NotFoundPage from '@/pages/NotFoundPage';

/** Escapes the SPA so CloudFront can serve docs/ui-design HTML on staging. */
export default function DesignPreviewRedirect() {
  const { pathname } = useLocation();
  const next = staticPreviewPath(pathname);

  useEffect(() => {
    if (next) window.location.replace(next);
  }, [next]);

  if (next) return null;
  return <NotFoundPage />;
}
